import routeFactory from '../../../../common/util/routeFactory';

export const accountRoleDetailRoutes = {
  accountRoleDetail: routeFactory.accountRoleDetail.routePath,
  accountRoleUsersDetail: routeFactory.accountRoleUsersDetail.routePath,
};
